// Package
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        label:{
            type: String,
            required: true,
            default: "",
        },
        disabled:{
            type: Boolean,
            required: false,
            default: false,
        },
        readonly:{
            type: Boolean,
            required: false,
            default: false,
        },
        name:{
            type: String,
            required: true,
            default: "",
        },
        value: {
            type: String | null,
            required: true,
            default: ""
        },
        errors:{
            type: Object,
            required: false,
            default: ()=>{},
        },
        type:{
            type: String,
            required: false,
            default: "text",
        },
        col:{
            type: String,
            required: false,
            default: "12",
        },
        information:{
            type: String,
            required: false,
            default: null,
        },
        required:{
            type: Boolean,
            required: false,
            default: false,
        }
    }
})